import React, { useEffect, useState } from "react"
import TransferItem from "./components/transferItem"
import axios from "axios"
import GLOBAL from "../../config/variable"
import { useUserContext } from "../../context/usercontext"
import { ProgressSpinner } from "primereact/progressspinner"
import { auth } from "../../firebase"

// Comps
import MyPointsHead from "../../components/MyPointsHead"

function TransferHistory() {
  const { user, loading: userLoading } = useUserContext()
  const [transfers, setTransfers] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchTransfers = async () => {
      try {
        setIsLoading(true)
        setError(null)
        const response = await axios.get(
          `${GLOBAL.SERVER_URL}/transactions/${user.uid}`,
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          }
        )
        setTransfers(response.data.data)
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Redirigir al login si la respuesta es 401
          auth.signOut()
        }
        console.error("Error fetching transfers:", error)
        setError("Error al cargar el historial de transferencias")
      } finally {
        setIsLoading(false)
      }
    }

    if (user?.uid) {
      fetchTransfers()
    }
  }, [user])

  // Si el contexto está cargando o no hay usuario, mostrar loading
  if (userLoading || !user) {
    return (
      <div className="container flex align-items-center justify-content-center">
        <ProgressSpinner />
      </div>
    )
  }

  // Si estamos cargando los datos, mostrar loading
  if (isLoading) {
    return (
      <div className="container flex align-items-center justify-content-center">
        <ProgressSpinner />
      </div>
    )
  }

  // Si hay error, mostrar mensaje de error
  if (error) {
    return (
      <div className="container flex align-items-center justify-content-center">
        <p className="text-red-500">{error}</p>
      </div>
    )
  }

  return (
    <div>
      <MyPointsHead />
      <div className="transfer-container mt-4">
        <div className="flex flex-column transfer-list-scroll gap-2 -mb-4">
          {transfers.length === 0 ? (
            <p className="text-white text-center">
              No hay transferencias disponibles
            </p>
          ) : (
            transfers.map((transfer) => (
              <TransferItem
                key={transfer.id}
                description={transfer.description}
                amount={transfer.points.toLocaleString("en-US")}
                status={transfer.status}
                type={transfer.transaction_type}
                date={transfer.date_created}
              />
            ))
          )}
        </div>
      </div>
    </div>
  )
}

export default TransferHistory
